import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "@/store/store";
import {
  setTransactionDetails,
  setDetailsLoading,
  setError,
  paymentSelector,
} from "@/store/features/paymentSlice";
import { usePaymentDetails } from "@/services/payment.services";

export const useTransactionDetails = (transactionId: string | null) => {
  const dispatch = useDispatch<AppDispatch>();
  const { transactionDetails, isDetailsLoading, error } = useSelector(paymentSelector);

  // Fetch transaction details
  const {
    data: transactionData,
    isLoading: detailsLoading,
    error: detailsError,
    refetch: refetchDetails,
  } = usePaymentDetails(transactionId || "");

  // Update Redux state when data changes
  useEffect(() => {
    if (transactionData) {
      dispatch(setTransactionDetails(transactionData));
    }
  }, [transactionData, dispatch]);

  useEffect(() => {
    dispatch(setDetailsLoading(detailsLoading));
  }, [detailsLoading, dispatch]);

  useEffect(() => {
    dispatch(setError(detailsError?.message || null));
  }, [detailsError, dispatch]);

  // Clear transaction details when transactionId changes to null
  useEffect(() => {
    if (!transactionId) {
      dispatch(setTransactionDetails(null));
    }
  }, [transactionId, dispatch]);

  // Helper functions
  const refreshDetails = () => {
    if (transactionId) {
      refetchDetails();
    }
  };

  const clearDetails = () => {
    dispatch(setTransactionDetails(null));
  };

  return {
    transactionDetails,
    isLoading: isDetailsLoading,
    error,
    refreshDetails,
    clearDetails,
  };
};
